import {Button, Col, Modal, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import Dropdown from "../../../../primer/Dropdown";
import {toast} from "react-toastify";
import axios from "axios";
import {setSelectedPrimerPos} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import moment from "moment";
import DateHelper from "../../../../primer/DateHelper/DateHelper";
import DateBox from "../../../../primer/DateBox";
import PrimerPosVodafoneReportChart from "./primer-pos-vodafone-report-chart";
import {useTranslation} from "../../../../../hooks/useTranslation";

const PrimerPosSimInfoModal = ({simInfo, setSimInfo}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const selectedPos = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPos);
    const [simStatus, setSimStatus] = useState(null);
    const [reportData, setReportData] = useState(null);
    const [simLoader, setSimLoader] = useState(false);
    const [simReportLoader, setSimReportLoader] = useState(false);
    const [requestData, setRequestData] = useState({date_from: moment().subtract("1", "month"), date_to: moment().toDate()});

    useEffect(() => {
        if(!isEmpty(simInfo?.state)){
            setSimStatus(simInfo.state);
            setReportData(null);
            setRequestData({date_from: moment().subtract("1", "month"), date_to: moment().toDate()});
        }
    }, [simInfo]);


    const getData = (key) => {
        return simInfo?.deviceInformationList?.deviceInformationItem?.find((el) => el?.itemName === key)?.itemValue || "";
    }

    const sessionUsageRows = [
        {
            started: getData("sessionLastStartedTimestamp"),
            ended: getData("sessionLastTerminatedTimestamp"),
            inBytes: parseFloat(getData("sessionBytesIn")),
            outBytes: parseFloat(getData("sessionBytesOut")),
        },
        {
            started: getData("sessionLastStartedTimestamp2"),
            ended: getData("sessionLastTerminatedTimestamp2"),
            inBytes: parseFloat(getData("sessionBytesIn2")),
            outBytes: parseFloat(getData("sessionBytesOut2")),
        }
    ].map(session => {
        const totalMB = Number(((session.inBytes + session.outBytes) / (1024 * 1024)) || 0).toFixed(2);
        const inMB = Number((session.inBytes / (1024 * 1024)) || 0).toFixed(2);
        const outMB = Number((session.outBytes / (1024 * 1024)) || 0).toFixed(2);
        return {
            date: moment(session.started).format("DD/MM/YYYY HH:mm:ss"),
            dateEnd: session.ended ? moment(session.ended).format("DD/MM/YYYY HH:mm:ss") : "",
            usage: `${totalMB} MB (Upload: ${inMB} MB, Download: ${outMB} MB)`
        };
    });

    const statusList = [
        { value: 'A', label: 'Active.Live' },
        { value: 'B', label: 'Inactive.New' },
        { value: 'C', label: 'Active.Sleep' },
        { value: 'D', label: 'Inactive.Stopped' },
        { value: 'I', label: 'Migrated from other VODAFONE GLOBAL IOT PLATFORM Environment' },
        { value: 'N', label: 'Not provisioned' },
        { value: 'O', label: 'Migrated to other VODAFONE GLOBAL IOT PLATFORM Environment' },
        { value: 'R', label: 'Active.Ready' },
        { value: 'S', label: 'Active.Suspend (NB service disabled)' },
        { value: 'T', label: 'Active.Test' },
        { value: 'U', label: 'Active.Standby' },
        { value: 'V', label: 'Inactive.Transformed' },
        { value: 'W', label: 'Suspend.Regulatory' },
        { value: 'X', label: 'Inactive' },
        { value: 'Z', label: 'Terminated (removed from GHLR)' },
    ];

    const statusListDropdownOptions = [
        { value: 'T', label: 'Active.Test' },
        { value: 'R', label: 'Active.Ready' },
        { value: 'A', label: 'Active.Live' },
        { value: 'D', label: 'Inactive.Stopped' },
        { value: 'S', label: 'Active.Suspend (NB service disabled)' },
    ];

    const changeSimStatus = () => {
        if(!isEmpty(simStatus) && !isEmpty(simInfo?.deviceId)) {
            const requestData = {_id: selectedPos?._id, action: "changeStatus", sim: simInfo?.deviceId, status: simStatus};
            setSimLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-vodafone-api", requestData, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSimLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        if(res.data?.data) setSimInfo(res.data.data);
                        if(res.data?.object) dispatch(setSelectedPrimerPos(res.data.object));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSimLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const getSimInfo = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber && !isEmpty(simInfo?.deviceId)) {
            const requestData = {_id: selectedPos?._id, action: "info", sim: simInfo?.deviceId}
            setSimLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-vodafone-api", requestData, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSimLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        if(res.data?.data) setSimInfo(res.data.data);
                        if(res.data?.object) dispatch(setSelectedPrimerPos(res.data.object));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSimLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const getSimReport = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber && !isEmpty(simInfo?.deviceId)) {
            setReportData(null);
            const data = {_id: selectedPos?._id, sim: simInfo?.deviceId, date_from: moment(requestData?.date_from, "DD/MM/YYYY").toDate(), date_to: moment(requestData?.date_to, "DD/MM/YYYY").toDate()}
            setSimReportLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-vodafone-report", data, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSimReportLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        if(res.data?.data) setReportData(res.data);
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSimReportLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    return (
        <Modal backdrop={"static"} className="themeModalBig" show={!isEmpty(simInfo)} onHide={() => setSimInfo(null)}>
            <Modal.Header closeButton>
                <Modal.Title>Πληροφορίες Κάρτας SIM</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <Row>
                        <Col md={3}>
                            <p className="text-muted mb-2"><i>Πληροφορίες Κάρτας:</i></p>
                        </Col>
                        <Col md={9}>
                            <Button
                                disabled={simLoader}
                                style={{marginLeft: "10px", marginRight: "10px"}}
                                className="mb-2 float-right"
                                size="sm"
                                onClick={() => getSimInfo()}>
                                Ενημέρωση Δεδομένων
                                {!simLoader && (<i className="fa-solid fa-rotate ml-1" style={{fontSize: "12px"}}></i>)}
                                {simLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <div className={"d-flex justify-content-between"}>
                            <table style={{width: "inherit", flex: 1}} className={"simpleClassicTable mr-2"}>
                                <thead>
                                <tr>
                                    <th colSpan={2}>Γενικές Πληροφορίες</th>
                                </tr>
                                </thead>
                                <colgroup>
                                    <col span={1} style={{width: "50%"}}></col>
                                    <col span={1} style={{width: "50%"}}></col>
                                </colgroup>
                                <tbody>
                                <tr><td>IMSI (Device Id)</td><td>{simInfo?.deviceId}</td></tr>
                                <tr><td>Κατάσταση SIM:</td><td style={{fontWeight: 'bolder'}}>{statusList?.find((el) => el?.value === simInfo?.state)?.label}</td></tr>
                                <tr><td>ICCID:</td><td>{getData("iccid")}</td></tr>
                                <tr><td>IMEI:</td><td>{getData("lastDetectedImei")}</td></tr>
                                <tr><td>APN Name:</td><td>{!isEmpty(simInfo?.apnList?.apnListItem?.apnName) ? simInfo.apnList.apnListItem.apnName : getData("apnName")}</td></tr>
                                <tr><td>Service Profile</td><td>{simInfo?.customerServiceProfile}</td></tr>
                                <tr><td>IP Address: </td><td>{getData("sessionLastIpAddress")}</td></tr>
                                </tbody>
                            </table>
                            <table style={{width: "inherit", flex: 1}} className={"simpleClassicTable mr-2"}>
                                <thead>
                                <tr>
                                    <th colSpan={2}>Χρήση Δεδομένων (Sessions)</th>
                                </tr>
                                </thead>
                                <colgroup>
                                    <col span={1}></col>
                                    <col span={1}></col>
                                </colgroup>
                                <tbody>
                                {sessionUsageRows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{`${row.date} - ${row.dateEnd}`}</td>
                                        <td>{row.usage}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </Row>
                    <hr />
                    <p className="text-muted mb-2"><i>Ενέργειες SIM:</i></p>
                    <Row className="align-items-center">
                        <Col md={4}>
                            <Dropdown
                                name={"simState"}
                                label={"Κατάσταση SIM"}
                                disabled={simLoader}
                                required={true}
                                key={Math.random()}
                                defaultValue={statusListDropdownOptions.find((el) => el.value === simStatus)}
                                options={statusListDropdownOptions}
                                onChange={(e) => setSimStatus(e.value)}
                            />
                        </Col>
                        <Col md={4}>
                            <Button
                                variant="primary"
                                disabled={simLoader}
                                onClick={() => changeSimStatus()}>
                                {"Αλλαγή Κατάστασης SIM "}
                                {simLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                            </Button>
                        </Col>
                    </Row>
                    <hr />
                    <p className="text-muted mb-2"><i>Κατανάλωση SIM:</i></p>
                    <Row>
                        <Col md={3}>
                            <DateHelper
                                dateFromAndToFunction={(from, to) => {
                                    setRequestData({...requestData, date_from: from, date_to: to});
                                }}
                            />
                        </Col>
                        <Col md={2}>
                            <DateBox
                                allowOtherYears={true}
                                name="date_from"
                                selected={isEmpty(requestData.date_from) ? moment().toDate() : moment(requestData.date_from, "DD/MM/YYYY").toDate()}
                                label={t('SalesBalanceSheet.dateFrom')}
                                onChange={(e) => setRequestData({...requestData, date_from: e})}
                            />
                        </Col>
                        <Col md={2}>
                            <DateBox
                                allowOtherYears={true}
                                name="date_to"
                                selected={isEmpty(requestData.date_to) ? moment().toDate() : moment(requestData.date_to, "DD/MM/YYYY").toDate()}
                                label={t('SalesBalanceSheet.dateTo')}
                                onChange={(e) => setRequestData({...requestData, date_to: e})}
                            />
                        </Col>
                        <Col md={"auto"} className="d-flex justify-content-end ms-auto">
                            <Button
                                variant="primary"
                                className={"mt-4"}
                                disabled={simReportLoader}
                                onClick={() => getSimReport()}>
                                {"Εφαρμογή Φίλτρων "}
                                {simReportLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                            </Button>
                        </Col>
                    </Row>
                    {(!isEmpty(reportData?.data) && !isEmpty(reportData?.grouping)) && (
                        <div className={"mt-3"} style={{padding: "15px", border: "2px solid lightgray", borderRadius: "15px"}}>
                        <PrimerPosVodafoneReportChart
                            data={reportData?.data}
                            grouping={reportData?.grouping}
                            stacked
                            unitLabel="MiB"
                            title="Vodafone Data Usage"
                        />
                        </div>
                    )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setSimInfo(null)}>
                    Κλείσιμο
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default PrimerPosSimInfoModal;